<template>
  <div class="login-body">
    <Toast/>

    <div class="login-panel"></div>

    <div class="login-content" :style="($vssWidth > 767 && $vssWidth < 1800 ? 'width: 47%' : '')">
      <img class="animation" src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB"
           style="margin-bottom: 2em"/>

      <h1 class="animation title1">{{ $t("landingPage.title1") }}</h1>
      <h1 class="animation title2">{{ $t("landingPage.title2") }}</h1>
      <p class="animation">{{ $t("landingPage.subtitle") }}</p>

      <div>
        <div class="col-12">
          <Button class="button-landing animation" icon="pi pi-angle-right" icon-pos="right" style="min-width:25em!important"
                  :label="$t('landingPage.latitude')" @click="$router.push('/')"/>
        </div>
        <div class="col-12" style="padding-top:.5em">
        <Button class="button-landing animation" icon="pi pi-angle-right" icon-pos="right" style="min-width:25em!important"
                :label="$t('landingPage.salesWeb')" @click="$endpoints.goToCofaceWebAssicurati()"/>
        </div>
        <ProgressSpinner v-if="loading" style="height: 2em;margin: 0 0 0 -2em;padding-top: 0.5em"/>

      </div>
    </div>
  </div>
</template>


<script>
import SsoService from "@/service/SsoService";
import {useUserStore} from "@/store/userStore";
import {useLoadingStore} from "@/store/loadingStore";
import {VueScreenSizeMixin} from 'vue-screen-size';
import gsap from "gsap";

export default {
  name: "LandingPage",
  mixins: [VueScreenSizeMixin],
  beforeCreate() {
    this.userStore = useUserStore()
    this.loadingStore = useLoadingStore()
  },
  created() {
    this.ssoService = new SsoService()
  },
  mounted() {
    gsap.from('.animation', {
      duration: 0.5,
      scale: 0,
      x: 200,
      ease: 'power1',
      stagger: {
        each: 0.1,
        from: 'left'
      }
    })
  },
  computed: {
    user() {
      return this.userStore.user
    },
    loading() {
      return this.loadingStore.loading
    }
  },
  methods: {
    goToSelectio() {
      this.$router.push('/')
    },
    goToLens() {
      window.open(this.lensEndpoint + '?token=' + this.user.token, '_blank')
    },
    dynamicLoginContent(width){
      switch (width){
        case this.$vssWidth > width:
         return 'width:50%'
        default:
          return 'width:100%'

      }
    }
  },

}
</script>

<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";
.title1 {
  font-size: 28px;
  font-weight: 500;
  margin: 14px 0;
  color: grey!important;
}
.title2 {
  font-size: 28px;
  font-weight: 500;
  margin: 14px 0 0 .5em;
  color: $blue2!important;
}
.login-body {
  padding: 0;
  margin: 0;
  min-height: 100vh;

  .login-panel {
    display: none;
  }

  .login-content {
    position: fixed;
    padding: 80px 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    text-align: center;

    img {
      display: inline-block;
      margin-bottom: 24px;
      width: 200px;
    }

    h1 {
      font-size: 28px;
      font-weight: 500;
      margin: 14px 0;
      color: black;

      span {
        color: gray;
      }
    }

    p {
      font-size: 17px;
      color: gray;
      margin: 0 0 32px 0;
    }

    .login-input-wrapper {
      position: relative;
      width: 300px;
      margin-bottom: 24px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;

      input {
        width: 100%;
        padding-right: 16px;
      }

      i {
        position: absolute;
        color: gray;
        font-size: 16px;
        top: 50%;
        right: .429em;
        margin-top: -8px;
      }
    }

    button {
      min-width: 150px;
    }
  }
}


@media screen and (min-width: 768px) {
  .login-body {
    background: url("../../public/assets/layout/images/pages/landing_page_bg.jpg");
    background-size: cover;

    .login-panel {
      padding: 80px;
      display: block;
      position: fixed;
      background-color: #ffffff;
      height: 200%;
      width: 100%;
      left: -50%;
      top: -50%;
      border-radius: 50%;
    }

    .login-content {
      text-align: left;
      position: fixed;
      padding: 80px 0 0 80px;

      .login-input-wrapper {
        width: 300px;
        margin-left: 0;
        margin-right: 0;
        text-align: left;
      }
    }
  }
}
</style>